import styled from 'styled-components';

const LeaderboardItemBody = styled.div``;

export default LeaderboardItemBody;
